(function ($) {
	'use strict';

	$(document).on('facetwp-loaded', function () {
		const labelsNames = {
			'resource_type': 'Filter Articles',
		}

		// Modified from...
		// https://facetwp.com/help-center/facets/#how-to-add-labels-headings-above-each-facet
		$('.facetwp-facet').each(function () {
			const facet = $(this);
			const facet_name = facet.attr('data-name');
			const facet_type = facet.attr('data-type');
			const facet_label = labelsNames[facet_name] || FWP.settings.labels[facet_name];
			const facet_label_class = labelsNames[facet_name] ? 'facet__label' : 'facet__label facet__label--hidden';

			if (facet_type !== 'pager') {
				if (facet.closest('.facet').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
					facet.wrap('<div class="facet"></div>');
					facet.before(`<label class="${facet_label_class}">` + facet_label + '</label>');

					if (facet_type !== 'checkboxes') {
						const facet_input = facet.find('input, select');
						facet_input.attr('id', `facet-${facet_name}`);
						facet.prev('.facet__label').attr('for', `facet-${facet_name}`);
					}
				}
			}
		});
	});
})(jQuery);
